export default "__VITE_ASSET__FlvGgv0p__"